/* eslint-disable */
import React from 'react'
import { useGLTF } from '@react-three/drei'

const Model = (props: any) => {
  const model = useGLTF(`/wp-content/uploads/2023/01/model.glb`)

  return (
    <group {...props} dispose={null}>
      <group position={[-200.98, -350.59, -786.15]}>
        <group position={[203.16, 343.37, 778.61]} rotation={[-2.43, -0.3, -1.9]} scale={0.74}>
          <mesh
            // @ts-ignore
            geometry={model.nodes.Sweep3.geometry}
            material={model.materials['New_Cinema White']}
            position={[0, -4.8, 0]}
          />
        </group>
      </group>
      <group position={[9.91, 0.43, 14.37]} rotation={[0.78, -0.8, 1.09]} scale={0.11}>
        <mesh
          // @ts-ignore
          geometry={model.nodes.Wave001.geometry}
          material={model.materials['New_Cinema White']}
        />
      </group>
      <mesh
        // @ts-ignore
        geometry={model.nodes.Capsule.geometry}
        material={model.materials['New_Cinema White']}
        position={[-11.44, -14.34, 5.14]}
        rotation={[1.92, 0.12, -0.64]}
        scale={0.11}
      />
      <mesh
        // @ts-ignore
        geometry={model.nodes.Sphere.geometry}
        material={model.materials['New_Cinema White']}
        position={[-17.5, 16.88, -1.48]}
        rotation={[0, -1.04, 0]}
        scale={0.11}
      />
      <mesh
        // @ts-ignore
        geometry={model.nodes.Sphere1.geometry}
        material={model.materials['New_Cinema White']}
        position={[14.46, 16.88, 17.37]}
        rotation={[0, -1.04, 0]}
        scale={0.11}
      />
      <mesh
        // @ts-ignore
        geometry={model.nodes.Torus.geometry}
        material={model.materials['New_Cinema Purple']}
        position={[-2.52, 2.16, 5.99]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.11}
      />
    </group>
  )
}

// useGLTF.preload(`/wp-content/uploads/2022/12/model.glb`)

export default Model
